<template>
  <div>
    <div class="center-align">
      <p>login</p>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'home',
    props: ['auth', 'authenticated'],
    computed: {
      ...mapState([
        'user'
      ])
    }
  }
</script>

<style scoped>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// Login.vue?8501fa4e